import { render, staticRenderFns } from "./backPrice.vue?vue&type=template&id=1fd3cfa9&scoped=true&"
import script from "./backPrice.vue?vue&type=script&lang=js&"
export * from "./backPrice.vue?vue&type=script&lang=js&"
import style0 from "./backPrice.vue?vue&type=style&index=0&id=1fd3cfa9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3cfa9",
  null
  
)

export default component.exports